// components/MembershipSpotlight.jsx
import React from 'react';
import { Box, Typography, Button, Container, Paper, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';

const MembershipSpotlight = () => {
  return (
    <Box 
      sx={{ 
        py: 12, 
        background: 'linear-gradient(135deg, #1a237e 0%, #283593 50%, #3949ab 100%)',
        position: 'relative',
        overflow: 'hidden',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        boxShadow: 'inset 0 5px 15px rgba(0,0,0,0.3), inset 0 -5px 15px rgba(0,0,0,0.3)',
      }}
    >
      {/* Background star elements */}
      {[...Array(30)].map((_, i) => (
        <Box
          key={i}
          component={FaStar}
          sx={{
            position: 'absolute',
            fontSize: Math.random() * 20 + 10,
            color: 'rgba(255, 255, 255, 0.2)',
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animation: `
              twinkle ${Math.random() * 3 + 2}s infinite alternate, 
              float ${Math.random() * 15 + 20}s infinite alternate,
              drift ${Math.random() * 25 + 30}s infinite linear
            `,
            '@keyframes twinkle': {
              '0%': { opacity: 0.1 },
              '100%': { opacity: 0.8 }
            },
            '@keyframes float': {
              '0%': { transform: 'translateY(0px)' },
              '50%': { transform: 'translateY(20px)' },
              '100%': { transform: 'translateY(-20px)' }
            },
            '@keyframes drift': {
              '0%': { marginLeft: '0px', marginTop: '0px' },
              '25%': { marginLeft: `${Math.random() * 20 - 10}px`, marginTop: `${Math.random() * 20 - 10}px` },
              '50%': { marginLeft: '0px', marginTop: '0px' },
              '75%': { marginLeft: `${Math.random() * -20 + 10}px`, marginTop: `${Math.random() * -20 + 10}px` },
              '100%': { marginLeft: '0px', marginTop: '0px' }
            }
          }}
        />
      ))}
      
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={7}>
            <Typography 
              variant="h2" 
              sx={{ 
                mb: 3, 
                fontWeight: 700, 
                color: 'white',
                textShadow: '0 2px 10px rgba(0,0,0,0.3)'
              }}
            >
              Join the Stellar Membership
            </Typography>
            <Typography 
              variant="h5" 
              sx={{ 
                mb: 4, 
                color: 'white', 
                fontWeight: 400,
                opacity: 0.9
              }}
            >
              Unlock exclusive perks, free tickets, and special privileges with our tiered membership program.
            </Typography>
            <Button 
              component={Link} 
              to="/membership" 
              variant="contained" 
              color="secondary" 
              size="large"
              sx={{ 
                fontWeight: 'bold',
                px: 4,
                py: 1.5,
                boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
              }}
            >
              Become a Member
            </Button>
          </Grid>
          <Grid item xs={12} md={5}>
            <Paper 
              elevation={8}
              sx={{
                p: 3,
                borderRadius: 4,
                background: 'linear-gradient(135deg, #122c44 0%, #1a3b5a 100%)',
                boxShadow: '0 15px 30px rgba(0,0,0,0.3)',
                border: '1px solid rgba(255,255,255,0.1)'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <FaStar size={24} color="#f5b400" />
                <Typography variant="h5" sx={{ ml: 1, fontWeight: 600, color: '#f5b400' }}>
                  Galaxy Tier Highlights
                </Typography>
              </Box>
              <Box component="ul" sx={{ pl: 2 }}>
                {[
                  'Two free tickets every month',
                  '15% off all concessions',
                  'Free refills on popcorn and drinks',
                  'Priority seating for blockbusters',
                  'Exclusive preview screenings',
                  'Birthday month bonus ticket'
                ].map((benefit, index) => (
                  <Typography 
                    component="li" 
                    key={index} 
                    sx={{ 
                      mb: 1,
                      color: 'white'
                    }}
                  >
                    {benefit}
                  </Typography>
                ))}
              </Box>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
                  $15/month
                </Typography>
                <Typography variant="body2" sx={{ color: 'white', opacity: 0.8 }}>
                  or $150/year
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default MembershipSpotlight;